import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/styles';
import Button from 'components/buttons/Button';
import BrokenLink from 'icons/brokenLink';
import { MIN_DESKTOP_WIDTH } from 'constants/misc';


const styles = theme => ({
  root: {
    height: '100vh',
    textAlign: 'center',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.secondary[100],
    padding: '2rem',
  },
  brokenLinkIcon: {
    color: theme.palette.white,
    marginBottom: '2rem',
    width: '8rem',
    height: '8rem',
    [`@media screen and (min-width: ${MIN_DESKTOP_WIDTH}px)`]: {
      width: '16rem',
      height: '16rem',
    },
  },
  title: {
    fontSize: '3.875rem',
    fontWeight: 'bold',
    marginBottom: '2rem',
  },
  homeBtn: {
    paddingLeft: '2rem !important',
    paddingRight: '2rem !important',
  },
});

const NotFound404 = (props) => {
  const { classes, history } = props;
  return (
    <div className={classes.root}>
      <BrokenLink className={classes.brokenLinkIcon} viewBox="0 0 234 234" />
      <h1 className={classes.title}>404</h1>
      <p className="mb-5">We couldn’t find the page you were looking for</p>
      <Button
        color="primary"
        variant="contained"
        className={classes.homeBtn}
        onClick={() => history.push('/')}
      >
        Go Home
      </Button>
    </div>
  );
};

NotFound404.propTypes = {
  classes: PropTypes.element.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default compose(
  withRouter,
  withStyles(styles),
)(NotFound404);
